// @flow
import * as React from 'react';
import cn from 'classnames';

// Components
import Modal from 'components/atoms/Modal';

import './ErrorModal.scss';

type Props = {
  className?: string,
  content: () => any,
  icon: () => any
};

export default class ErrorModal extends React.Component<Props> {
  static block = 'error-modal';

  constructor(props: Props, context: any) {
    super(props, context);
    (this: any).modal = React.createRef();
  }

  setShowModal = (show: boolean = true) => {
    (this: any).modal.current.setShowModal(show);
  };

  modal: React.Ref<any>;

  render() {
    const { className, content, icon, ...props } = this.props;
    const ns = ErrorModal.block;
    const classProps = cn(ns, className);

    return (
      <Modal
        className={classProps}
        ref={this.modal}
        showCloseButton={true}
        {...props}
      >
        {icon()}
        {content()}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/api/containers/ErrorModal/ErrorModal.js